import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  // Format price with two decimal places
  return price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
